import { gaugeConfig } from "../../config/configurations";
import { DrawSplitsProps } from "../../domain/types";

export const drawSplits = ({
  chart,
  values,
  gaugeType,
}: DrawSplitsProps) => {
  const { ctx, chartArea: { left, right } } = chart;
  ctx.save();

  const { splitsWidth } = gaugeConfig[gaugeType];

  const meta = chart.getDatasetMeta(0);
  const arc = meta.data[0];
  const cx = arc.x;
  const cy = arc.y;
  const radius = arc.outerRadius;

  ctx.beginPath();
  ctx.lineWidth = splitsWidth;
  ctx.strokeStyle = "#fff";

  // ctx.moveTo(cx - 0.58 * radius, cy + 0.5 * radius);
  // ctx.lineTo(cx - 0.31 * radius, cy - 0.085 * radius);
  // ctx.stroke();

  // ctx.moveTo(cx - 0.23 * radius, cy - 0.28 * radius);
  // ctx.lineTo(cx - 0.195 * radius, cy - 0.24 * radius);
  // ctx.stroke();

  // ctx.moveTo(cx, cy - 0.71 * radius);
  // ctx.lineTo(cx, cy - 0.60 * radius);
  // ctx.stroke();

  // ctx.moveTo(cx + 0.23 * radius, cy - 0.28 * radius);
  // ctx.lineTo(cx + 0.19 * radius, cy - 0.235 * radius);
  // ctx.stroke();

  // ctx.moveTo(cx + 0.37 * radius, cy - 0.1 * radius);
  // ctx.lineTo(cx + 0.305 * radius, cy - 0.085 * radius);
  // ctx.stroke();

  // --- Labels ---
  ctx.font = `normal ${radius * 0.13}px Cera-Pro`;
  ctx.fillStyle = "rgba(255, 255, 255, 0.4)";
  ctx.textAlign = "center";

  const temp = values.minValue !== 0 ? values.minValue : 0;
  const sectionValue = values.total / 4;

  ctx.fillText(Math.round(sectionValue + temp), cx - 0.52 * radius, cy - 0.18 * radius);
  ctx.fillText(Math.round(sectionValue * 2 + temp), cx + 0.02 * radius, cy - 0.59 * radius);
  ctx.fillText(Math.round(sectionValue * 3 + temp), cx + 0.52 * radius, cy - 0.18 * radius);

  // minValue
  ctx.textAlign = "left";
  ctx.fillText(Math.round(values.minValue), cx - 0.52 * radius, cy + 0.37 * radius);

  // maxValue
  ctx.textAlign = "right";
  ctx.fillText(Math.round(values.maxValue), cx + 0.52 * radius, cy + 0.37 * radius);

  ctx.restore();

};

export default drawSplits;
